import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '~/store/apis/baseQuery/baseQuery';

export const onboardingUnauthenticatedApi = createApi({
  reducerPath: 'onboardingUnauthenticatedApi',
  endpoints: () => ({}),
  baseQuery: baseQuery(import.meta.env.VITE_API_SVC_ONBOARDING_BASE_URL, false),
});
